import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";
import {LocalidadTurnoModel} from "../model/localidadTurno.model";


@Injectable({
  providedIn: 'root'
})
export class ParametrizacionLocalidadesTurnosService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.parametrizacion.localidadTurno.getAll);
  }

  guardarLocalidadTurno(localidadTurno: LocalidadTurnoModel) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.parametrizacion.localidadTurno.create + '', localidadTurno);
  }

  actualizarLocalidadTurno(localidadTurno: LocalidadTurnoModel) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.parametrizacion.localidadTurno.update + localidadTurno.id + '', localidadTurno);
  }

  borrarLocalidadTurno(localidadTurno: LocalidadTurnoModel) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.parametrizacion.localidadTurno.delete + localidadTurno.id + '');
  }

}
